/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGINATION
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	pagination: {
		width: 'fit-content',
		marginRight: 'auto',
		marginLeft: 'auto',
		'& .arrow': {
			background: convertHexToRGB(theme.color.supporting.dark.swatch, 5),
			color: theme.color.primary.medium.swatch,
			cursor: 'pointer',
			borderRadius: pxToEm(4),
			display: 'inline-flex',
			justifyContent: 'center',
			alignContent: 'center',
			alignItems: 'center',
			height: pxToEm(36),
			width: pxToEm(36),
			transition: 'all .15s linear 0s',
			'&:hover': {
				filter: 'brightness(35%)'
			},
			'&.disabled': {
				'&-true': {
					// background: convertHexToRGB(theme.color.supporting.dark.swatch, 2),
					color: theme.color.grey.medium.swatch,
					cursor: 'default',
					pointerEvents: 'none'
				}
			}
		},
		'& .status': {
			// margin: replacePXinStringWithEM(`0px 20px`),
			display: 'inline-flex',
			justifyContent: 'center',
			alignContent: 'center',
			alignItems: 'center',
			width: pxToEm(130),
		}
	}
});